function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import BuildingBlocksTabsMobileComponent from "segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-mobile-component/building-blocks-tabs-mobile-component";
import { useMemo } from "react";
import { StyledPlatformInteractiveExperienceHomepageFirstFoldMobileComponent } from "./platform-interactive-experience-homepage-first-fold-mobile-component.scss";
import { convertInteractionToTab } from "../../util/interaction_tab_convertor";
const PlatformInteractiveExperienceHomepageFirstFoldMobileComponent = (props)=>{
    const { interactions } = props;
    const tabs = useMemo(()=>{
        var _interactions_map;
        return (_interactions_map = interactions === null || interactions === void 0 ? void 0 : interactions.map((interaction)=>convertInteractionToTab(interaction))) !== null && _interactions_map !== void 0 ? _interactions_map : [];
    }, [
        interactions
    ]);
    return /*#__PURE__*/ _jsx(StyledPlatformInteractiveExperienceHomepageFirstFoldMobileComponent, {
        className: "platform-interactive-experience-homepage-first-fold-mobile-component",
        children: /*#__PURE__*/ _jsx(BuildingBlocksTabsMobileComponent, _object_spread_props(_object_spread({}, props), {
            tabs: tabs,
            displayContentTitle: true
        }))
    });
};
export default PlatformInteractiveExperienceHomepageFirstFoldMobileComponent;
